import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { inr, fmtDate } from "@/lib/utils-format";
import { Building2, ChevronRight } from "lucide-react";

export default function VendorLedgerPanel() {
  const [rows, setRows] = useState([]);
  const [detail, setDetail] = useState(null);

  const load = async () => {
    const { data } = await api.get("/vendor-purchases/ledger");
    setRows(data);
  };
  useEffect(() => { load(); }, []);

  const openVendor = async (vendorId) => {
    const { data } = await api.get(`/vendor-purchases/ledger/${vendorId}`);
    setDetail(data);
  };

  return (
    <div className="space-y-4" data-testid="vendor-ledger-panel">
      <div className="uc-label">HO Vendor Ledger — snack/beverage suppliers</div>
      <div className="bg-white border border-[#EAE5D9] rounded-lg overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left uc-label border-b border-[#EAE5D9]">
              <th className="px-4 py-3">Vendor</th><th className="px-4 py-3 text-right">Purchases</th>
              <th className="px-4 py-3 text-right">Total Bought</th><th className="px-4 py-3 text-right">Returned</th>
              <th className="px-4 py-3 text-right">Paid</th><th className="px-4 py-3 text-right">Balance Due</th><th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.vendor_id} className="border-b border-[#EAE5D9] last:border-0 hover:bg-[#FDFBF7] cursor-pointer" onClick={() => openVendor(r.vendor_id)} data-testid={`vendor-ledger-row-${r.vendor_id}`}>
                <td className="px-4 py-3 font-medium flex items-center gap-2"><Building2 className="w-3.5 h-3.5 text-[#8B7355]" />{r.vendor_name}</td>
                <td className="px-4 py-3 text-right">{r.purchase_count}</td>
                <td className="px-4 py-3 text-right">{inr(r.total_purchased)}</td>
                <td className="px-4 py-3 text-right text-red-600">{r.total_returned > 0 ? `-${inr(r.total_returned)}` : "—"}</td>
                <td className="px-4 py-3 text-right">{inr(r.total_paid)}</td>
                <td className="px-4 py-3 text-right font-semibold">{r.balance_due > 0.5 ? <span className="text-red-600">{inr(r.balance_due)}</span> : <span className="text-emerald-600">₹0</span>}</td>
                <td className="px-4 py-3 text-right"><ChevronRight className="w-4 h-4 text-[#8B7355] inline" /></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="text-center py-10 text-[#8B7355]">No vendor purchases recorded yet.</td></tr>}
          </tbody>
        </table>
      </div>

      <Dialog open={!!detail} onOpenChange={(o) => !o && setDetail(null)}>
        <DialogContent className="max-w-2xl bg-white max-h-[90vh] overflow-y-auto">
          {detail && (
            <>
              <DialogHeader><DialogTitle className="font-[Outfit]">{detail.vendor.name} — Purchase History</DialogTitle></DialogHeader>
              <div className="grid grid-cols-3 gap-3 text-sm">
                <div className="bg-[#F7F2E8] rounded-md p-3"><div className="text-xs text-[#8B7355]">Total Bought</div><div className="font-semibold text-lg">{inr(detail.totals.total_purchased)}</div></div>
                <div className="bg-[#F7F2E8] rounded-md p-3"><div className="text-xs text-[#8B7355]">Total Paid</div><div className="font-semibold text-lg">{inr(detail.totals.total_paid)}</div></div>
                <div className="bg-[#F7F2E8] rounded-md p-3"><div className="text-xs text-[#8B7355]">Balance Due</div><div className="font-semibold text-lg text-[#C05621]">{inr(detail.totals.balance_due)}</div></div>
              </div>
              <div className="space-y-1.5">
                {detail.transactions.map((t, i) => (
                  <div key={i} className="flex items-center justify-between text-sm border-b border-[#EAE5D9] py-1.5" data-testid={`vendor-ledger-txn-${i}`}>
                    <div className="flex items-center gap-2">
                      <Badge variant="outline" className={
                        t.type === "purchase" ? "border-orange-300 text-orange-700 bg-orange-50" :
                        t.type === "payment" ? "border-emerald-300 text-emerald-700 bg-emerald-50" :
                        "border-red-300 text-red-700 bg-red-50"
                      }>{t.type}</Badge>
                      <span className="font-medium">{t.number}</span>
                      {t.reason && <span className="text-xs text-[#8B7355]">· {t.reason}</span>}
                      {t.method && <span className="text-xs text-[#8B7355] capitalize">· {t.method} {t.reference && `(${t.reference})`}</span>}
                    </div>
                    <div className="text-right">
                      <div className={t.amount < 0 ? "text-emerald-600" : "font-medium"}>{t.amount < 0 ? "-" : ""}{inr(Math.abs(t.amount))}</div>
                      <div className="text-[10px] text-[#8B7355]">{fmtDate(t.date)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
